/**
 * The authenticated operator's display name, readable outside React.
 *
 * F-PUB-012: 22 ticket screens and `operatorCommandRegistry` hardcoded a single
 * developer's name as the default "Submitted By". On create the backend derives
 * `created_by` from the authenticated principal so the literal never reached the
 * database, but it was still shown to every user as though they were that person,
 * and the update path used to trust whatever the client sent.
 *
 * `AuthContext` persists the signed-in user to localStorage, so this reads the
 * same record without needing the hook — which matters for the non-component
 * callers (`operatorCommandRegistry` is a plain module).
 */
export const getCurrentOperatorName = (): string => {
  try {
    const stored = localStorage.getItem('user');
    if (!stored) return '';
    const user = JSON.parse(stored);
    return user?.fullName || user?.username || '';
  } catch {
    // Corrupt or unavailable storage: an empty operator is honest, a guessed one is not.
    return '';
  }
};

/** Authenticated principal identifier used by backend maker/checker controls. */
export const getCurrentOperatorUsername = (): string => {
  try {
    const stored = localStorage.getItem('user');
    if (!stored) return '';
    const user = JSON.parse(stored);
    return user?.username || '';
  } catch {
    return '';
  }
};
